import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { CreateCompany } from '@/pages/auth/create-company/CreateCompany';

// `?step=billing&companyID=…` was the billing step signup no longer has. Old links still parse, and
// `CreateCompany` sends them on to company settings, where the billing address is edited.
const searchSchema = z.object({
	step: z.literal('billing').optional(),
	companyID: z.string().optional(),
});

export const Route = createFileRoute('/_authenticated/create-company')({
	validateSearch: searchSchema,
	component: CreateCompany,
});
